import { render, staticRenderFns } from "./Bases.vue?vue&type=template&id=2a611a1c"
import script from "./Bases.vue?vue&type=script&lang=js"
export * from "./Bases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports